export default __webpack_public_path__ + "static/1-3d017584ea6cee79a561a5f3606182f0.jpg";